import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ProfilePicture, Button, FormSelect } from '@getro/rombo';
import { ChevronRight } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { openChat } from 'helpers/supportChat';
import { useClaimCompany } from '../hooks/useClaimCompany';

export const Company = ({ activeNetwork }) => {
  const { handleSearch, company, setCompany } = useClaimCompany(activeNetwork);
  const history = useHistory();
  const [error, setError] = useState(false);

  return (
    <Flex sx={{ gap: '40px', flexDirection: 'column', alignItems: 'flex-start', width: '360px', mt: '218px' }}>
      <Flex width="100%" sx={{ gap: '16px', flexDirection: 'column', alignItems: 'flex-start' }}>
        <ProfilePicture
          width="48px"
          height="48px"
          variant="square"
          imageUrl={activeNetwork.logoUrl}
          name={activeNetwork.name}
          sx={{ flex: '0 0 auto' }}
        />
        <Text fontSize="24px" fontWeight="700" color="text.dark" lineHeight="120%">
          Claim your company profile
        </Text>
        <Text sx={{ color: 'text.main', fontSize: '18px' }}>
          Use {activeNetwork.name}&apos;s influence and exposure to promote and fill open roles.
        </Text>
      </Flex>

      <Flex sx={{ width: '100%', flexDirection: 'column', gap: '24px' }}>
        <Box
          sx={{
            width: '100%',
          }}
        >
          <FormSelect
            label="Select your company"
            isSearchable
            defaultOptions
            loadOptions={handleSearch}
            isAsync
            name="company"
            onChange={(value) => {
              setCompany(value);
              setError(false);
            }}
            placeholder="Start typing..."
            value={company}
            orientation="horizontal"
            field={{
              name: 'company',
            }}
            form={{
              touched: {
                company: error,
              },
              errors: {
                company: 'Select your company',
              },
            }}
            anchorToBody
            sx={{ '.Search__control': { borderColor: 'neutral.400' } }}
          />
        </Box>
        <Button
          onClick={() => {
            if (company?.value) {
              history.push(`/claim-your-profile/${activeNetwork.slug}/company/${company?.value}`);
              return;
            }

            setError(true);
          }}
          icon={ChevronRight}
          iconPosition="right"
          sx={{ justifyContent: 'center' }}
          variant="primary"
        >
          Continue
        </Button>
      </Flex>

      <Box>
        <Text color="text.subtle" fontSize="14px" fontWeight="400">
          Can&apos;t find your company? If it belongs to {activeNetwork.name}{' '}
          <Box
            as="span"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => openChat(null, { name: 'Support' })}
          >
            contact us
          </Box>
          .
        </Text>
      </Box>
    </Flex>
  );
};

Company.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
};
